import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import {
  LargeHeadingStyled,
  MediumLargeHeadingStyled,
} from "src/components/custom/texts/texts.styled";

function PaymentReturn() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<string>("Consultando");
  const [mensaje, setMensaje] = useState<string>("Verificando el estado de su pago...");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const estado = searchParams.get("estado");
    const pagoId = searchParams.get("pagoId");

    if (estado === "aprobado" && pagoId && pagoId !== "0") {
      sessionStorage.removeItem("powerTranzOrderId");
      sessionStorage.removeItem("powerTranzSpiToken");
      navigate(`/last-receipt/${pagoId}/${null}`);
    } else if (estado === "rechazado") {
      sessionStorage.removeItem("powerTranzOrderId");
      navigate(
        `/payment-error/${encodeURIComponent("El-pago-fue-rechazado-por-la-entidad-bancaria")}`,
      );
    } else {
      setStatus("Error");
      setMensaje("No se pudo completar el pago. Por favor, contacte al departamento financiero.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "70vh",
        gap: "15px",
      }}
    >
      {status === "Consultando" && <Spin size="large" />}
      <LargeHeadingStyled>
        {status === "Consultando" ? "Procesando pago" : "Error en el pago"}
      </LargeHeadingStyled>
      <MediumLargeHeadingStyled style={{ maxWidth: 750, textAlign: "center" }}>
        {mensaje}
      </MediumLargeHeadingStyled>
    </div>
  );
}

export default PaymentReturn;
